import React, { useState, useEffect } from "react";
import "./styles.css";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Spin,
  notification,
  Modal,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ImageZoomModal from "../../../components/ImageZoomModal";
import { db, storage } from "../../../services/firebase";
import {
  collection,
  getDocs,
  doc,
  setDoc,
  updateDoc,
  serverTimestamp,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";

import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { registrarAtividade } from "../../../services/atividadeService";
import {
  ArrowLeftOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseOutlined,
  SaveOutlined,
  FileTextOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

const { Item, useForm } = Form;

function ValvulaBloqueioForm({ valvula }) {
  const [form] = useForm(); // hook
  const [fileList, setFileList] = useState([]);
  const [fileListPlaqueta, setFileListPlaqueta] = useState([]);
  const [clientes, setClientes] = useState([]); // Estado para armazenar a lista de clientes
  const [unidades, setUnidades] = useState([]);
  const [fullscreenLoading, setFullscreenLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [lastValveId, setLastValveId] = useState(null); // Armazena o ID da última válvula cadastrada
  const [certificados, setCertificados] = useState([]); // Certificados vinculados à válvula
  const [zoomModal, setZoomModal] = useState({ visible: false, images: [], index: 0, title: "" });
  const navigate = useNavigate();

  // imagens que vem do firebase
  const [imagesValvula, setImagesValvula] = useState([]);
  const [imagesPlaqueta, setImagesPlaqueta] = useState([]);

  const handleChangeUpload = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const handleChangeUploadPlaqueta = ({ fileList: newFileList }) =>
    setFileListPlaqueta(newFileList);

  const getUnidades = (id) => {
    const resultado = clientes.find((cliente) => cliente.id === id);
    setUnidades(resultado?.unidades || []);
    form.setFieldValue("unidadeCliente", "");
  };

  // Função para buscar a lista de clientes
  useEffect(() => {
    const fetchClientesFirebase = async () => {
      try {
        const snapshot = await getDocs(collection(db, "clientes"));
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setClientes(data);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };
    fetchClientesFirebase();
  }, []);

  async function uploadFile(id) {
    try {
      if (fileList.length > 0) {
        await Promise.all(
          fileList.map((file) =>
            uploadBytesResumable(
              ref(storage, `${id}/valvula/${file.originFileObj.name}`),
              file.originFileObj
            )
          )
        );
      }
      if (fileListPlaqueta.length > 0) {
        await Promise.all(
          fileListPlaqueta.map((file) =>
            uploadBytesResumable(
              ref(storage, `${id}/plaqueta/${file.originFileObj.name}`),
              file.originFileObj
            )
          )
        );
      }
    } catch (error) {
      console.error("Erro ao fazer upload de imagens:", error);
      notification.error({
        message: "Erro no upload de imagens",
        description:
          "As imagens não foram enviadas. Por favor, tente novamente ou entre em contato com o suporte.",
        placement: "topRight",
      });
      throw error; // Re-throw para o handleSubmit saber que houve erro
    }
  }

  //Enviar dados ao backend
  function gerarIdDataHora() {
    const agora = new Date();
    const doisDigitos = (num) => String(num).padStart(2, "0");

    const dia = doisDigitos(agora.getDate());
    const mes = doisDigitos(agora.getMonth() + 1);
    const ano = agora.getFullYear().toString().slice(-2);
    const hora = doisDigitos(agora.getHours());
    const min = doisDigitos(agora.getMinutes());
    const seg = doisDigitos(agora.getSeconds());

    return `${dia}${mes}${ano}${hora}${min}${seg}`; // Ex: 110425153001
  }

  const FullscreenSpinner = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size="large" tip="Processando..." />
    </div>
  );

  const handleValidate = (values) => {
    const entries = Object.entries(values);
    const validate = entries.map(([key, value]) => {
      if (value === undefined) {
        return [key, ""];
      }
      return [key, value];
    });

    const data = Object.fromEntries(validate);
    return data;
  };

  // salvar uma nova válvula
  const handleSubmit = async (values, redirectToCertificate = false) => {
    const id = "VB" + gerarIdDataHora();
    setFullscreenLoading(true); // <- precisa disso aqui no começo!

    const data = handleValidate(values);

    // Converter os campos de data para Date e adicionar data de cadastro
    const dataFormatada = {
      ...data,
      dataCalibracao: values.dataCalibracao
        ? values.dataCalibracao?.toDate()
        : "",
      proximaCalibracao: values.proximaCalibracao
        ? values.proximaCalibracao?.toDate()
        : "",
      tipoValvula: "Bloqueio",
      dataCadastro: serverTimestamp(), // ⏱️ campo oculto no Firestore
    };

    try {
      await setDoc(doc(db, "valvulasBloqueio", id), dataFormatada); // coleção correta
      await uploadFile(id);

      // Registrar atividade
      const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario"));
      const cliente = clientes.find((c) => c.id === values.cliente_id);
      const nomeCliente = cliente?.nomeEmpresa || "";
      await registrarAtividade(
        "Válvula Bloqueio cadastrada",
        `${values.tag} • ${nomeCliente}`,
        usuario?.nomeUsuario
      );

      setLastValveId(id); // Armazena o ID para possível navegação

      notification.success({
        message: "Válvula cadastrada com sucesso!",
        description: redirectToCertificate
          ? "Redirecionando para cadastro de certificado..."
          : "Os dados foram salvos no sistema.",
        placement: "topRight",
      });

      if (redirectToCertificate) {
        // Navega para o cadastro de certificado com os dados da válvula
        navigate(`/admin/cadastro-certificado?valvula_id=${id}`);
      } else {
        // Apenas limpa o formulário
        form.resetFields();
        setFileList([]);
        setFileListPlaqueta([]);
      }
    } catch (error) {
      console.error("Erro ao cadastrar válvula:", error);
      notification.error({
        message: "Erro ao cadastrar válvula",
        description: "Tente novamente.",
        placement: "topRight",
      });
    } finally {
      setFullscreenLoading(false);
    }
  };

  // atualizar uma válvula
  const handleSave = async (values) => {
    setFullscreenLoading(true);
    const id = valvula.id;

    const data = handleValidate(values);

    try {
      const ref = doc(db, "valvulasBloqueio", id);
      await updateDoc(ref, {
        ...data,
        dataCalibracao: values.dataCalibracao
          ? values.dataCalibracao?.toDate()
          : "",
        proximaCalibracao: values.proximaCalibracao
          ? values.proximaCalibracao?.toDate()
          : "",
      });
      await uploadFile(id);

      // Registrar atividade
      const usuario = JSON.parse(sessionStorage.getItem("seepilUsuario"));
      const cliente = clientes.find((c) => c.id === values.cliente_id);
      const nomeCliente = cliente?.nomeEmpresa || "";
      await registrarAtividade(
        "Válvula Bloqueio atualizada",
        `${values.tag} • ${nomeCliente}`,
        usuario?.nomeUsuario
      );

      notification.success({
        message: "Válvula atualizada com sucesso!",
        description: "As alterações foram salvas.",
        placement: "topRight",
      });

      setIsEditing(false); // incluiremos esse controle no próximo passo
    } catch (error) {
      console.error("Erro ao atualizar válvula:", error);
      notification.error({
        message: "Erro ao atualizar válvula",
        description: "Tente novamente.",
        placement: "topRight",
      });
    } finally {
      setFullscreenLoading(false);
    }
  };

  async function getFiles() {
    const listValvulaRef = ref(storage, `${valvula.id}/valvula`);
    const listPlaquetaRef = ref(storage, `${valvula.id}/plaqueta`);

    const [resultadoValvula, resultadoPlaqueta] = await Promise.all([
      listAll(listValvulaRef),
      listAll(listPlaquetaRef),
    ]);

    const imagesValvula = await Promise.all(
      resultadoValvula.items.map((image) => getDownloadURL(image))
    );
    const imagesPlaqueta = await Promise.all(
      resultadoPlaqueta.items.map((image) => getDownloadURL(image))
    );

    setImagesValvula(imagesValvula);
    setImagesPlaqueta(imagesPlaqueta);
  }

  // Função para buscar certificados vinculados à válvula
  const fetchCertificados = async (valvulaId) => {
    try {
      const q = query(
        collection(db, "certificados"),
        where("valvula_id", "==", valvulaId)
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCertificados(data);
    } catch (error) {
      console.error("Erro ao buscar certificados:", error);
    }
  };

  useEffect(() => {
    if (valvula) {
      const dataCalibracao =
        valvula?.dataCalibracao !== ""
          ? dayjs(valvula?.dataCalibracao?.toDate())
          : "";
      const proximaCalibracao =
        valvula?.proximaCalibracao !== ""
          ? dayjs(valvula?.proximaCalibracao?.toDate())
          : "";
      form.setFieldsValue({ ...valvula, dataCalibracao, proximaCalibracao });
      getFiles();
      fetchCertificados(valvula.id); // Buscar certificados vinculados
      return;
    }

    form.resetFields();
    setFileList([]);
    setFileListPlaqueta([]);
    setImagesValvula([]);
    setImagesPlaqueta([]);
    setCertificados([]);
  }, [valvula]);

  const mostrarModalConfirmacaoDelete = (id) => {
    Modal.confirm({
      title: "Deseja deletar esta válvula?",
      content: "Essa ação não poderá ser desfeita.",
      okText: "Sim, deletar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        deletarValvula(id); // chama a função que você vai criar agora
      },
    });
  };

  const deletarValvula = async (id) => {
    try {
      await deleteDoc(doc(db, "valvulasBloqueio", id));
      notification.success({
        message: "Válvula deletada com sucesso!",
        description: "Os dados foram removidos do sistema.",
      });
      navigate("/admin/valvulas"); // redireciona após deletar
    } catch (error) {
      console.error("Erro ao deletar válvula:", error);
      notification.error({
        message: "Erro ao deletar válvula",
        description: "Tente novamente mais tarde.",
      });
    }
  };

  return (
    <>
      {fullscreenLoading && <FullscreenSpinner />}
      {!fullscreenLoading && (
        <Form
          onFinish={valvula ? handleSave : handleSubmit}
          layout="vertical"
          form={form}
          className="custom-form"
          initialValues={{
            unidadeInlet: "pol",
            unidadeOutlet: "pol",
            unidadeNormaFlange: "ASME",
          }}
        >
          <h2 className="tituloValvula">VÁLVULA DE BLOQUEIO</h2>

          {/* Identificação */}
          <div className="form-row">
            <Item label="Cliente" name="cliente_id" required>
              <Select
                disabled={valvula && !isEditing}
                onChange={getUnidades}
                required
                placeholder="Selecione um cliente"
              >
                {clientes.map((cliente) => (
                  <Select.Option key={cliente.id} value={cliente.id}>
                    {cliente.nomeEmpresa}
                  </Select.Option>
                ))}
              </Select>
            </Item>
            <Item label="Unidade" name="unidadeCliente" required>
              <Select
                disabled={valvula && !isEditing}
                required
                placeholder="Selecione uma unidade"
              >
                {unidades.map((unidade, index) => (
                  <Select.Option key={index} value={unidade.unidade}>
                    {unidade.unidade}
                  </Select.Option>
                ))}
              </Select>
            </Item>
            <Item label="Tipo" name="tipo" required>
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="VBO">CHOKE</Select.Option>
                <Select.Option value="VBO">VBO</Select.Option>
                <Select.Option value="VBO">VDI</Select.Option>
                <Select.Option value="VES">VES</Select.Option>
                <Select.Option value="VGA">VGA</Select.Option>
                <Select.Option value="VBO">VGI</Select.Option>
                <Select.Option value="VGL">VGL</Select.Option>
                <Select.Option value="VBO">VMA</Select.Option>
                <Select.Option value="VRE">VRE</Select.Option>
                <Select.Option value="VBO">VTP</Select.Option>
              </Select>
            </Item>
          </div>

          {/* Dados do Equipamento */}
          <div className="form-row">
            <Item label="Tag" name="tag">
              <Input disabled={valvula && !isEditing} placeholder="Tag" />
            </Item>
            <Item label="Fabricante" name="fabricante">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Modelo" name="modelo">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
          </div>

          {/* Dimensões Inlet */}
          <p className="form-section-title">Inlet</p>
          <div className="form-row">
            <Item label="Diâmetro Inlet" name="diametroInlet" required>
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Unidade" name="unidadeInlet" required>
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="pol">pol</Select.Option>
                <Select.Option value="mm">mm</Select.Option>
              </Select>
            </Item>
            <Item label="Classe de Pressão Inlet" name="classePressaoInlet">
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="125#">125#</Select.Option>
                <Select.Option value="150#">150#</Select.Option>
                <Select.Option value="300#">300#</Select.Option>
                <Select.Option value="600#">600#</Select.Option>
                <Select.Option value="900#">900#</Select.Option>
                <Select.Option value="1,500#">1,500#</Select.Option>
                <Select.Option value="2,500#">2,500#</Select.Option>
                <Select.Option value="3,000#">3,000#</Select.Option>
                <Select.Option value="5,000#">5,000#</Select.Option>
                <Select.Option value="10,000#">10,000#</Select.Option>
                <Select.Option value="15,000#">15,000#</Select.Option>
                <Select.Option value="20,000#">20,000#</Select.Option>
                <Select.Option value="2K">2K</Select.Option>
                <Select.Option value="5K">5K</Select.Option>
                <Select.Option value="10K">10K</Select.Option>
                <Select.Option value="16K">16K</Select.Option>
                <Select.Option value="20K">20K</Select.Option>
                <Select.Option value="30K">30K</Select.Option>
                <Select.Option value="40K">40K</Select.Option>
                <Select.Option value="50K">50K</Select.Option>
                <Select.Option value="63K">63K</Select.Option>
                <Select.Option value="PN 6">PN 6</Select.Option>
                <Select.Option value="PN 10">PN 10</Select.Option>
                <Select.Option value="PN 16">PN 16</Select.Option>
                <Select.Option value="PN 25">PN 25</Select.Option>
                <Select.Option value="PN 40">PN 40</Select.Option>
                <Select.Option value="PN 63">PN 63</Select.Option>
                <Select.Option value="PN 100">PN 100</Select.Option>
                <Select.Option value="PN 160">PN 160</Select.Option>
                <Select.Option value="PN 250">PN 250</Select.Option>
                <Select.Option value="PN 320">PN 320</Select.Option>
                <Select.Option value="PN 400">PN 400</Select.Option>
              </Select>
            </Item>
          </div>

          {/* Dimensões Outlet */}
          <p className="form-section-title">Outlet</p>
          <div className="form-row">
            <Item label="Diâmetro Outlet" name="diametroOutlet" required>
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Unidade" name="unidadeOutlet">
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="pol">pol</Select.Option>
                <Select.Option value="mm">mm</Select.Option>
              </Select>
            </Item>
            <Item label="Classe de Pressão Outlet" name="classePressaoOutlet">
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="125#">125#</Select.Option>
                <Select.Option value="150#">150#</Select.Option>
                <Select.Option value="300#">300#</Select.Option>
                <Select.Option value="600#">600#</Select.Option>
                <Select.Option value="900#">900#</Select.Option>
                <Select.Option value="1,500#">1,500#</Select.Option>
                <Select.Option value="2,500#">2,500#</Select.Option>
                <Select.Option value="3,000#">3,000#</Select.Option>
                <Select.Option value="5,000#">5,000#</Select.Option>
                <Select.Option value="10,000#">10,000#</Select.Option>
                <Select.Option value="15,000#">15,000#</Select.Option>
                <Select.Option value="20,000#">20,000#</Select.Option>
                <Select.Option value="2K">2K</Select.Option>
                <Select.Option value="5K">5K</Select.Option>
                <Select.Option value="10K">10K</Select.Option>
                <Select.Option value="16K">16K</Select.Option>
                <Select.Option value="20K">20K</Select.Option>
                <Select.Option value="30K">30K</Select.Option>
                <Select.Option value="40K">40K</Select.Option>
                <Select.Option value="50K">50K</Select.Option>
                <Select.Option value="63K">63K</Select.Option>
                <Select.Option value="PN 6">PN 6</Select.Option>
                <Select.Option value="PN 10">PN 10</Select.Option>
                <Select.Option value="PN 16">PN 16</Select.Option>
                <Select.Option value="PN 25">PN 25</Select.Option>
                <Select.Option value="PN 40">PN 40</Select.Option>
                <Select.Option value="PN 63">PN 63</Select.Option>
                <Select.Option value="PN 100">PN 100</Select.Option>
                <Select.Option value="PN 160">PN 160</Select.Option>
                <Select.Option value="PN 250">PN 250</Select.Option>
                <Select.Option value="PN 320">PN 320</Select.Option>
                <Select.Option value="PN 400">PN 400</Select.Option>
              </Select>
            </Item>
          </div>

          {/* Especificações Técnicas */}
          <p className="form-section-title">Especificações</p>
          <div className="form-row">
            <Item label="Norma de Flange" name="normaFlange">
              <Select disabled={valvula && !isEditing}>
                <Select.Option value="ASME">ASME</Select.Option>
                <Select.Option value="DIN">DIN</Select.Option>
                <Select.Option value="JIS">JIS</Select.Option>
                <Select.Option value="ROSCA">ROSCA</Select.Option>
              </Select>
            </Item>
            <Item label="Material do Corpo" name="materialCorpo">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Material da Sede" name="materialSede">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
          </div>

          <div className="form-row">
            <Item label="Face a Face (mm)" name="face">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Tipo de Castelo" name="tipoCastelo">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
            <Item label="Acionamento" name="acionamento">
              <Input disabled={valvula && !isEditing} placeholder="" />
            </Item>
          </div>

          {/* Observações */}
          <p className="form-section-title">Observações</p>
          <Item name="observacoes">
            <Input.TextArea
              rows={3}
              placeholder="Observações adicionais..."
              disabled={valvula && !isEditing}
            />
          </Item>

          {/* Uploads */}
          <p className="form-section-title">Fotos</p>
          <div className="form-row-2">
            <div className="upload-box">
              <label className="upload-box-label">Fotos da Válvula</label>
              <Upload
                disabled={valvula && !isEditing}
                listType="picture"
                fileList={fileList}
                onChange={handleChangeUpload}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />} className="upload-btn">
                  Selecionar arquivos
                </Button>
              </Upload>
              {imagesValvula.length > 0 && (
                <div className="images-grid">
                  {imagesValvula.map((item, idx) => (
                    <img
                      key={idx}
                      src={item}
                      alt="Válvula"
                      onClick={() => setZoomModal({ visible: true, images: imagesValvula, index: idx, title: "Fotos da Válvula" })}
                    />
                  ))}
                </div>
              )}
            </div>

            <div className="upload-box">
              <label className="upload-box-label">Fotos da Plaqueta</label>
              <Upload
                disabled={valvula && !isEditing}
                listType="picture"
                fileList={fileListPlaqueta}
                onChange={handleChangeUploadPlaqueta}
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />} className="upload-btn">
                  Selecionar arquivos
                </Button>
              </Upload>
              {imagesPlaqueta.length > 0 && (
                <div className="images-grid">
                  {imagesPlaqueta.map((item, idx) => (
                    <img
                      key={idx}
                      src={item}
                      alt="Plaqueta"
                      onClick={() => setZoomModal({ visible: true, images: imagesPlaqueta, index: idx, title: "Fotos da Plaqueta" })}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Botões para nova válvula */}
          {!valvula && (
            <div style={{ display: "flex", gap: "8px", marginTop: 16 }}>
              <Button
                className="submitBotao"
                htmlType="submit"
                icon={<PlusOutlined />}
              >
                Cadastrar Válvula
              </Button>
              <Button
                className="submitBotao btn-destaque"
                icon={<PlusOutlined />}
                onClick={() => {
                  form
                    .validateFields()
                    .then((values) => {
                      handleSubmit(values, true);
                    })
                    .catch((errorInfo) => {
                      notification.error({
                        message: "Campos obrigatórios faltando",
                        description:
                          "Por favor, preencha todos os campos obrigatórios antes de continuar.",
                        placement: "topRight",
                      });
                    });
                }}
              >
                Cadastrar Válvula + Certificado
              </Button>
            </div>
          )}

          {/* Botão de "Editar Válvula" se já existir e não estiver no modo edição */}
          {valvula && !isEditing && (
            <div style={{ display: "flex", gap: "8px", marginTop: 16, flexWrap: "wrap" }}>
              <Button
                className="submitBotao"
                style={{ marginTop: 0 }}
                onClick={() => setIsEditing(true)}
                icon={<EditOutlined />}
              >
                Editar Válvula
              </Button>

              {/* Botão de Certificado */}
              {certificados.length === 0 ? (
                <Button
                  className="submitBotao btn-destaque"
                  style={{ marginTop: 0 }}
                  icon={<FileTextOutlined />}
                  onClick={() => navigate(`/admin/cadastro-certificado?valvula_id=${valvula.id}`)}
                >
                  Criar Certificado
                </Button>
              ) : (
                <Button
                  className="submitBotao btn-certificado"
                  style={{ marginTop: 0 }}
                  icon={<FileDoneOutlined />}
                  onClick={() => navigate(`/admin/cadastro-certificados/${certificados[0].id}`)}
                >
                  Ver Certificado {certificados.length > 1 ? `(${certificados.length})` : ""}
                </Button>
              )}
            </div>
          )}

          {/* Botões de "Salvar Alterações" e "Cancelar" no modo edição */}
          {valvula && isEditing && (
            <div style={{ display: "flex", gap: "8px", marginTop: 16 }}>
              <Button
                htmlType="submit"
                className="submitBotao"
                type="primary"
                icon={<SaveOutlined />}
              >
                Salvar Alterações
              </Button>
              <Button
                className="submitBotao"
                icon={<CloseOutlined />}
                onClick={() => setIsEditing(false)}
              >
                Cancelar Edição
              </Button>
            </div>
          )}
          {valvula && (
            <Button
              className="submitBotao"
              icon={<DeleteOutlined />}
              danger
              type="primary"
              onClick={() => mostrarModalConfirmacaoDelete(valvula.id)}
            >
              Deletar Válvula
            </Button>
          )}
        </Form>
      )}

      <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}
      >
        <Button
          className="voltarBotao"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>

      <ImageZoomModal
        visible={zoomModal.visible}
        images={zoomModal.images}
        currentIndex={zoomModal.index}
        title={zoomModal.title}
        onClose={() => setZoomModal((m) => ({ ...m, visible: false }))}
      />
    </>
  );
}

export default ValvulaBloqueioForm;
